import { render } from "./LottieAnimation.vue?vue&type=template&id=5c9aee66&scoped=true"
import script from "./LottieAnimation.vue?vue&type=script&lang=js"
export * from "./LottieAnimation.vue?vue&type=script&lang=js"

import "./LottieAnimation.vue?vue&type=style&index=0&id=5c9aee66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9aee66"]])

export default __exports__